var PageOrderSearch = (function ($) {

    PageOrderSearch = function (options) {
        var that = this;

        // DOM
        that.$wrapper = options['$wrapper'];
        that.$js_show_help = that.$wrapper.find('.js-show-help');
        that.$order_search_help_header = that.$wrapper.find('.js-order-search-help-modal-header');
        that.$order_search_help_body = that.$wrapper.find('.js-order-search-help-modal-body');

        // CONST
        that.modal = options['modal'];

        // DYNAMIC VARS

        // INIT
        that.init();
    };

    PageOrderSearch.prototype.init = function () {
        var that = this;
        that.initHelpModal();
    };

    PageOrderSearch.prototype.initHelpModal = function () {
        var that = this;

        that.$js_show_help.on('click', function () {
            $.uiModal({
                mobile_fullscreen: false,
                disable_content_scroll: true,
                $wrapper: $(that.modal['help']),
            });
        });
    };

    return PageOrderSearch;
})($);
